import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getSurgeryMonitorByRecordID(recordID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/surgery/monitor?recordID=${recordID}`;

    return httpGet(apiUrl);
  }

  appendSurgeryMonitor(recordID, status) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/surgery/monitor?recordID=${recordID}`;

    return httpPost(apiUrl, status);
  }

  modifySurgeryMonitorByRecordID(recordID, statusID, monitor) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/surgery/monitor?recordID=${recordID}&statusID=${statusID}`;

    return httpPut(apiUrl, monitor);
  }
}
